import { createFileRoute } from "@tanstack/react-router";
import AdminOutreachLog from "@/pages/AdminOutreachLog";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/outreach-log/")({
  component: () => (
    <RoleGate allow={['staff','viewer']} area="Outreach Log"><AdminOutreachLog /></RoleGate>
  ),
});
